import { parseJSON } from 'common/utils/json';

interface ITrainingPermissions {
    canReadGroups?: boolean;
    canManageGroups?: boolean;
    canUpdate?: boolean;
    canImportUsers?: boolean;
    canManageParticipants?: boolean;
    canReadParticipants?: boolean;
}

export const getTrainingPermissions = (
    training?: { permissions?: string | null } | null
): ITrainingPermissions => parseJSON(training?.permissions || '') || {};
